import React, { PropTypes } from 'react';
import Forms from '../forms';
import Login from '../login';
import Overlay from './overlay';

function WrapOverlay({ showedOverlay, setOverlay }) {
  if (!showedOverlay) {
    return null;
  }

  if (showedOverlay.indexOf('forms__') === 0) {
    return (
      <Overlay setOverlay={setOverlay}>
        <Forms showedOverlay={showedOverlay} />
      </Overlay>
    );
  }

  if (showedOverlay.indexOf('login') === 0) {
    return (
      <Overlay setOverlay={setOverlay}>
        <Login />
      </Overlay>
    );
  }
}

WrapOverlay.propTypes = {
  setOverlay: PropTypes.func.isRequired,
  showedOverlay: PropTypes.string
};

export default WrapOverlay;



// WEBPACK FOOTER //
// ../src/components/overlay/index.jsx